export default "__VITE_ASSET__D1KkQgWs__"